/**
 * Asset types for media attachments
 */

export interface Asset {
  id: string;
  name: string;
  type: 'image' | 'video' | 'pdf' | 'text';
  content?: string;  // For text type assets
  url?: string;      // GCS URL or public URL
  tags: string[];
  created_at: string;
  updated_at: string;
}

export interface AssetsResponse {
  assets: Asset[];
  total: number;
}

export type MediaType = 'image' | 'video' | 'document';

// Map asset types to WhatsApp media types
export const assetTypeToMediaType = (assetType: Asset['type']): MediaType => {
  switch (assetType) {
    case 'image':
      return 'image';
    case 'video':
      return 'video';
    case 'pdf':
      return 'document';
    default:
      return 'document';
  }
};
